/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SettingsIdOrdersGetItem } from './settingsIdOrdersGetItem';
import { UserIdOrdersGetItem } from './userIdOrdersGetItem';
import { PaymentIdOrdersGetItem } from './paymentIdOrdersGetItem';
import { InvoiceIdOrdersGetItem } from './invoiceIdOrdersGetItem';
import { LineItemIdOrdersGetItem } from './lineItemIdOrdersGetItem';


/**
 * 
 */
export interface OrderIdOrdersGetItem { 
    userAccount?: UserIdOrdersGetItem | null;
    lineItems?: Array<LineItemIdOrdersGetItem>;
    subtotal?: string | null;
    total?: string | null;
    shipping?: string | null;
    fees?: string | null;
    gstIncluded?: string | null;
    feesExplanation?: string | null;
    status: OrderIdOrdersGetItem.StatusEnum;
    origin?: OrderIdOrdersGetItem.OriginEnum;
    /**
     * The payment ledger - an order can be settled in more than one go (see Payment).
     */
    payments?: Array<PaymentIdOrdersGetItem>;
    outstanding?: string | null;
    dateCompleted?: string | null;
    paymentMethod?: OrderIdOrdersGetItem.PaymentMethodEnum | null;
    stripePaymentIntent?: string | null;
    settingsApplied?: SettingsIdOrdersGetItem | null;
    invoice?: InvoiceIdOrdersGetItem | null;
    nbr?: string;
    id?: string | null;
    readonly lineItemTotal?: string;
    /**
     * Gross received - what came in, before anything went back.
     */
    readonly amountPaid?: string;
    /**
     * What has been given back on this order.
     */
    readonly amountRefunded?: string;
    /**
     * Received less refunded - what TLC actually kept.
     */
    readonly netAmountPaid?: string;
    /**
     * Has any money gone back on this order? Drives the CRM badge.
     */
    readonly refunded?: boolean;
    /**
     * What\'s still owed, derived from the ledger. Falls back to the stored value for orders taken before the ledger existed (and for any flow that never records a Payment), so nothing that worked before changes behaviour.
     */
    readonly outstandingFromPayments?: string;
    readonly fullyPaid?: boolean;
    readonly dateCreated?: string | null;
}
export namespace OrderIdOrdersGetItem {
    export type StatusEnum = 'PENDING' | 'COMPLETE' | 'CANCELLED';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Complete: 'COMPLETE' as StatusEnum,
        Cancelled: 'CANCELLED' as StatusEnum
    };
    export type OriginEnum = 'WEB' | 'IN_PERSON';
    export const OriginEnum = {
        Web: 'WEB' as OriginEnum,
        InPerson: 'IN_PERSON' as OriginEnum
    };
    export type PaymentMethodEnum = 'EFT' | 'CASH';
    export const PaymentMethodEnum = {
        Eft: 'EFT' as PaymentMethodEnum,
        Cash: 'CASH' as PaymentMethodEnum
    };
}


